const DB_NAME = 'chamii.local-files.v1'
const STORE_NAME = 'files'

function openDb() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1)
    req.onupgradeneeded = () => {
      const db = req.result
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: 'id' })
      }
    }
    req.onsuccess = () => resolve(req.result)
    req.onerror = () => reject(req.error || new Error('failed to open indexedDB'))
  })
}

function randomId() {
  try {
    return crypto.randomUUID()
  } catch {
    return `f_${Date.now()}_${Math.random().toString(16).slice(2)}`
  }
}

export function isIdbUrl(url) {
  return typeof url === 'string' && url.startsWith('idb:')
}

export function parseIdbUrl(url) {
  if (!isIdbUrl(url)) return null
  const id = url.slice('idb:'.length).trim()
  return id ? { id } : null
}

export async function putFile(blob, { name = 'file', type = '' } = {}) {
  if (!blob) throw new Error('missing blob')
  const db = await openDb()
  const id = randomId()
  const record = {
    id,
    name: String(name || 'file'),
    type: String(type || blob.type || ''),
    blob,
    createdAt: Date.now(),
  }

  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readwrite')
    tx.oncomplete = () => resolve(`idb:${id}`)
    tx.onerror = () => reject(tx.error || new Error('failed to store file'))
    tx.objectStore(STORE_NAME).put(record)
  })
}

export async function getFileBlob(idbUrlOrId) {
  const parsed = typeof idbUrlOrId === 'string' ? parseIdbUrl(idbUrlOrId) : null
  const id = parsed?.id || String(idbUrlOrId || '').trim()
  if (!id) return null

  const db = await openDb()
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readonly')
    const req = tx.objectStore(STORE_NAME).get(id)
    req.onsuccess = () => resolve(req.result?.blob || null)
    req.onerror = () => reject(req.error || new Error('failed to read file'))
  })
}

